import React from "react";

import {
  StyledImagePresenter,
  StyledImagePresenterProps,
  StyledImg,
  StyledImgProps,
} from "./styled";

type ImagePresenterProps = {
  src?: string;
  onClick?: () => void;
} & StyledImagePresenterProps &
  StyledImgProps;

export const ImagePresenter: React.FC<ImagePresenterProps> = ({
  src,
  onClick,
  ...styles
}) => {
  const [aspectRatio, setAspectRatio] = React.useState<string>();
  const imgRef = React.useRef<HTMLImageElement>(null);

  const onLoaded = () => {
    setAspectRatio(`${imgRef?.current?.width}/${imgRef?.current?.height}`);
  };

  return (
    <StyledImagePresenter
      onClick={onClick}
      aspectRatio={aspectRatio}
      {...styles}
    >
      <StyledImg src={src} {...styles} onLoad={onLoaded} ref={imgRef} />
    </StyledImagePresenter>
  );
};
